
import { ParallaxEffect, ParallaxContext } from '../ParallaxEffect';
import { BaseParallaxEffect } from '../BaseParallaxEffect';

export class CoralReefEffect extends BaseParallaxEffect implements ParallaxEffect {
    public render(pc: ParallaxContext): void {
        const { ctx, layerIndex, config, height } = pc;
        const spacing = (150 + layerIndex * 100) / (config.parallaxPatternDensity || 1.0);
        const { x1, x2 } = this.getGridBounds(pc, spacing);
        const scale = config.parallaxScale || 1.0;

        ctx.fillStyle = pc.color;

        for (let x = x1; x <= x2; x += spacing) {
            const h = (80 + this.pseudoRandom(x) * 120) * scale;
            const y = height - layerIndex * 50;
            
            const draw = () => {
                ctx.beginPath();
                ctx.moveTo(x - spacing * 0.2, y);
                ctx.quadraticCurveTo(x, y - h, x + spacing * 0.2, y);
                ctx.fill();
                
                // Branches
                const twigs = Math.floor(3 * (config.parallaxComplexity || 1.0));
                for(let i=0; i<twigs; i++) {
                    const bx = x + (this.pseudoRandom(x+i) - 0.5) * spacing * 0.1;
                    const by = y - h * (0.3 + i * 0.2);
                    const br = 15 * scale;
                    ctx.beginPath();
                    ctx.arc(bx, by, br, 0, Math.PI * 2);
                    ctx.fill();
                }
            };
            draw();
            this.applyGlow(pc, draw);
        }
    }
}
